import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {freckleFactPracticeLevelsPdfUrl} from '@freckle/classroom/ts/math/fact-practice/logic/fact-practice-session-history-logic'
import {factPracticeLink} from './fact-practice-report-info.module.scss'

export function FactPacticeReportInfo() {
  const {t} = useSafeTranslation()

  return (
    <div className="row std-margin-top-xlg std-margin-bottom-md">
      <div className="col-12">
        <Link
          target="_blank"
          rel="noopener"
          href={freckleFactPracticeLevelsPdfUrl}
          reactRouter={false}
          className={factPracticeLink}
        >
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="1x" />{' '}
          {t('FACT_PRACTICE_LEVEL_LINK')}
        </Link>
      </div>
    </div>
  )
}
